import { Dropdown } from 'components/common'
import { memo, useEffect, useState } from 'react'
import { fetchStores } from 'utils/api/storeApi'

type Props = {
  setValue: any
  error?: string
  label: string
  name: string
  required?: boolean
  isActive?: boolean
  hintText?: string
  withNoneOption?: boolean
  defaultValue?: string
}

const StoreDropdown = ({
  setValue,
  error,
  label,
  name,
  required,
  isActive,
  hintText,
  withNoneOption = false,
  defaultValue,
}: Props) => {
  const [options, setOptions] = useState<any>([])
  const [loading, setLoading] = useState<boolean>(true)

  const getStores = async () => {
    try {
      const { data } = await fetchStores({
        limit: 500,
        page: 1,
        isActive,
        // third-party stores are handled by a separate flow
        isThirdPartyStore: false,
      })

      const stores = data?.docs?.map((store: any) => ({
        label: store.storeName,
        value: store._id,
        disabled: false,
      }))

      if (!stores || stores.length <= 0) {
        return setOptions([])
      }

      if (withNoneOption === true) {
        stores.unshift({
          label: '--NONE--',
          value: '',
          disabled: false,
        })
      }

      setOptions(stores)
    } catch (error) {
      setOptions([])
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    getStores()
  }, [])

  if (loading) {
    return <></>
  }

  return (
    <Dropdown
      required={required}
      label={label}
      name={name}
      setValue={setValue}
      error={error}
      hintText={hintText}
      defaultValue={defaultValue}
      options={
        options.length <= 0
          ? [
              {
                label: 'No Stores Found',
                value: 'NO_STORES',
                disabled: true,
              },
            ]
          : options
      }
    />
  )
}

export default memo(StoreDropdown)
